import { render, staticRenderFns } from "./AchievementDialog.vue?vue&type=template&id=4db20124&"
import script from "./AchievementDialog.vue?vue&type=script&lang=js&"
export * from "./AchievementDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports